import { makeStyles } from "@mui/styles";

const feedbackStyle = makeStyles((theme) => ({
    feedbackPanel: {
        position: "absolute",
        top: "70px",
        left: "1.5rem !important",
        width: "470px",
        height: "600px",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        color: 'rgba(11, 33, 56, 0.98)',
        borderRadius: "23px",
        boxShadow: "2px 2px 10px rgba(0,0,0,0.2)",
        padding: "1.3rem",
        transition: "left 0.3s ease-in-out",
        zIndex: 100,
        overflowY: "auto",
        [theme.breakpoints.down("sm")]: {
            width: '300px',
            height: "350px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
        },
    },
    open: {
        opacity: 1,
    },
    closed: {
        display: "none",
    },
    panelHeader: {
        display: "flex",
        fontWeight: "bold !important",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: "10px",
        marginBottom: "10px",
        paddingLeft: "1rem",
        paddingTop: "1rem",
    },
    feedbackTitle: {
        fontSize: "1.3rem !important",
        fontWeight: "bold !important",
        color: "#2b3a56",
        textAlign: "center",
        marginBottom: "10px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.6rem !important",
            textAlign: "center",
        },
    },
    feedbackContent: {
        marginTop: "10px",
        paddingRight: "1rem",
        paddingLeft: "1rem",
        display: "flex",
        flexDirection: "column",
        gap: "13px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.6rem !important",
            Scale: 1.2,
        },
    },
    feedbackText: {
        fontSize: "15px !important",
        textAlign: "justify",
        color: "rgba(11, 33, 56, 0.98)",
        lineHeight: "1.5",
        marginBottom: "10px",
        marginRight: "10px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "17px !important",
            textAlign: "center",
        },
    },
    ratingRow: {
        display: "flex",
        alignItems: "top",
        justifyContent: "space-between",
        gap: "45px",
        width: "100%",
        padding: "13px 0",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
        },
    },
    ratingContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px 0",
    },
    button: {
        marginTop: "15px",
        backgroundColor: "#1f78d1",
        color: "#fff",
        "&:hover": {
            backgroundColor: "rgba(80, 139, 195, 0.4)"
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem !important",
        },
    },
    dashedLine: {
        border: "none",
        borderTop: "1px dashed #999",
        margin: "10px 0",
        width: "100%",
    },
    subButton: {
        flex: 1,
        textAlign: "center",
        backgroundColor: "rgba(80, 139, 195, 0.9) !important",
        color: "#fff !important",
        "&:hover": {
            backgroundColor: "rgb(52, 103, 150)!important",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem !important",
        },
    },
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            borderColor: "#ccc",
            "& fieldset": {
                borderColor: "rgba(11, 33, 53, 0.4)",
            },
            "&:hover fieldset": {
                borderColor: "#1f78d1",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#1f78d1",
                boxShadow: "0 0 5px rgba(31, 120, 209, 0.3)",
            },
        },
        "& .MuiInputLabel-root": {
            color: "rgba(11, 33, 53, 0.7) !important",
            fontSize: "15px",
        },
        "& .MuiInputBase-input::placeholder": {
            color: "rgba(11, 33, 53, 0.9) !important",
            opacity: 1,
        },
    },
    nameFieldsContainer: {
        display: "flex",
        gap: "10px",
        width: "100%",
    },
    nameField: {
        flex: 1,
    },
    checkboxContainer: {
        "& .MuiCheckbox-root": {
            color: "rgba(11, 33, 53, 0.6)!important",
        },
        "& .Mui-checked": {
            color: "#1f78d1 !important",
        },
        "& .MuiTypography-root": {
            fontSize: "15px !important",
        },
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        width: "100%",
        paddingTop:"0.7rem",
        paddingBottom: "0.7rem",
    },
    halfButton: {
        flex: 1,
        textAlign: "center",
    },

}));

export default feedbackStyle;
